<template>
    <layout>
        <v-row 
            align="center"
            justify="center"
        >
            <v-card
                class="mt-7"
                width="500"
                flat
                outlined
            >  
            
                <v-toolbar 
                    flat
                >
                    <v-toolbar-title>Term Reports</v-toolbar-title>  
                </v-toolbar>

                <v-card
                    flat
                    class="pa-3"
                >
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        fixed-header
                        height="50vh"
                        class="custom-table"
                    >
                        <template v-slot:item="{ item }">
                            <tr @click="displayReport(item)">
                                <td class="px-0">
                                    <div class="card">
                                        <div>{{ item.title }}</div>
                                        <div>{{ item.headline }}</div>
                                        <div>{{ item.subtitle }}</div>
                                    </div>
                                </td>
                                <td class="px-0">
                                    <div class="card d-flex flex-column justify-end">
                                        <span class="d-flex justify-end mb-2 text-caption" v-if="item.posted">Posted</span>
                                        <span class="d-flex justify-end text-caption" v-else>Not Posted</span>
                                        <span class="d-flex justify-end">
                                            <v-btn
                                                color="primary"
                                                outlined
                                                small
                                                @click="displayReport(item)"
                                            >
                                                View Report
                                            </v-btn>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
                
            </v-card>
        </v-row>

        <v-overlay
            :value="overlay"
            opacity="0.8"
            z-index="10"                    
        >
            
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>                   
        </v-overlay>
        
        
        <v-dialog
            v-model="reportCard"
            max-width="700px"
            persistent
        >
            <v-card
               height="90vh" 
            >                
                <iframe 
                    ref="pdf" 
                    style="width:100%; height:92%" 
                    class="report-viewer" 
                    :src="src"
                ></iframe>              
                <v-overlay
                    absolute
                    :value="reportViewerOverlay"
                    color="white"
                    opacity="0.60"
                >
                    <v-progress-circular
                        indeterminate
                        size="64"
                        color="primary"
                    ></v-progress-circular>
                </v-overlay>
                
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        @click="closeReport"
                    >
                        Close Report
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>        
    </layout>    
</template>

<script>
import Layout from './layouts/App';
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
    name: 'TermReport',
    components: {
        Layout,
    },

    created(){
        this.initialize();
    },
    
    data: () => ({
        reportCard: false,
        selected: -1,
        items: [],
        src: '',
        reportViewerOverlay: false, 
        overlay: false, 
        headers:[
            { text: 'Report', value: 'term', sortable: false },
            { text: '', value: 'action', sortable: false },
        ] ,
        loading: false,     
    }),

    computed:{
        ...mapGetters({
            studentRecord: 'auth/getStudentRecord',
            reportTerms: 'report/getReportTerms'                    
        }),
    },
    methods: {
        ...mapActions({
            getAcademicTerms: 'report/getAcademicTerms',
        }),
        
        ...mapMutations({
            setOverlay: 'auth/setOverlay',
        }),

        displayReport(item){           
            let term_id = item.term;
            let form_class_id = item.form_class_id;
            this.reportCard = true;
            this.reportViewerOverlay = true;
            this.$nextTick( function () {            
                this.$refs.pdf.onload = () => {
                    console.log('report is loaded');
                    this.reportViewerOverlay = false;
                }
            })
            this.src = process.env.VUE_APP_API_URI + 
            `/api/report-card?academicTermId=${term_id}&` +
            `formClassId=${form_class_id}&`+
            `studentId=${this.studentRecord.id}&`+
            `user=student`
        },

        async initialize(){
            this.overlay = true;
            await this.getAcademicTerms({ id: this.studentRecord.id });
            this.reportTerms.forEach(term => {
                if(term.posted){
                    this.items.push({
                        title: 'Form ' + term.form_level,
                        action: term.term_end,
                        headline: 'End of Term Report',
                        subtitle: 'Term ' + term.term + ' ' + term.academic_year,
                        term: term.academic_term_id,
                        form_class_id: term.form_class_id,
                        posted: true
                    })
                }
                else{
                    this.items.push({
                        title: 'Form ' + term.form_level,
                        action: term.term_end,
                        headline: 'End of Term Report',
                        subtitle: 'Term ' + term.term + ' ' + term.academic_year,
                        term: term.academic_term_id,
                        form_class_id: term.form_class_id,
                        posted: false
                    })
                }
               
            });
            this.overlay = false;
        },
        closeReport(){
            console.log('report closing ...');
            this.src = '';
            this.selected = -1;
            this.reportCard = false;
        }
    }
   
    
}
</script>

<style scoped>
    ::v-deep .v-list-item.v-list-item--disabled.v-list-item--link.theme--light {
        background: gainsboro;
    }

     ::v-deep .custom-table{
        border-collapse: separate;
        border-spacing: 0 14px;
    }

    ::v-deep .card{
        background: rgb(212, 245, 222);
        padding: 14px;
        margin-top: 12px;
        margin-bottom: 12px;
        height: 80px;
    }

    td:first-child .card {
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
    }

    td:last-child .card {
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
    }

    ::v-deep .v-data-table .v-data-table__wrapper table tbody tr:hover{
        background: transparent !important;
        cursor: pointer;
        
    }

    .v-data-table .v-data-table__wrapper table tbody tr td{
        border-bottom: none !important;
    }
</style>